"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useZoom = useZoom;

var _react = require("react");

var _useViewerContext2 = require("./use-viewer-context");

function useZoom() {
  var _useViewerContext = (0, _useViewerContext2.useViewerContext)(),
      viewer = _useViewerContext.viewer,
      isReady = _useViewerContext.isReady;

  return (0, _react.useMemo)(function () {
    return {
      zoomIn: function zoomIn() {
        return isReady ? viewer.viewport.zoomBy(1 / 0.7) : null;
      },
      zoomOut: function zoomOut() {
        return isReady ? viewer.viewport.zoomBy(0.7) : null;
      }
    };
  }, [isReady, viewer]);
}